import {Constants} from "../constants";
import {Util} from "../util/util";

export class ModalUtil {

    static hasSeenWelcomeModal(): boolean {
        return Util.parseJson(sessionStorage.getItem(Constants.WELCOME_MESSAGE_SEEN));
    }

    static hasSeenSocialWelcomeModal(): boolean {
        return Util.parseJson(sessionStorage.getItem(Constants.SHAREABLE_WELCOME_SEEN));
    }

    static rememberWelcomeModalOpened(): void {
        sessionStorage.setItem(Constants.WELCOME_MESSAGE_SEEN, JSON.stringify(true));
        ModalUtil.rememberSocialWelcomeModalOpened();
    }

    static rememberSocialWelcomeModalOpened(): void {
        sessionStorage.setItem(Constants.SHAREABLE_WELCOME_SEEN, JSON.stringify(true));
    }
}
